const notificationtemplates = {
	title: "Notification Templates",
	new_notificationtemplate: "New Notification Template",
	edit_notificationtemplate: "Edit Notification Template: {name}",
	view_notificationtemplate: "View Notification Template: {name}",
	list_title: "List of Notification Templates",
	create_title: "Create Notification Template",
	update_title: "Update Notification Template",
	id: "ID",
	tags_title: "Notification Template Tags",
	subject: "Subject",
	template: "Template",
	trigger: "Trigger",
	description: "Short description",
	slug: "Slug",
	tag: "Tags",
	type: "Type",
	available_tags: "Available tags",
};
export default notificationtemplates;